module.exports = __webpack_public_path__ + "img/icon-unsubscribe.7e68c14f.png";